// *******************************************************************************
// Add class to body after some scroll
// *******************************************************************************
let ticking = false;
let lastScrollTop = 0;

const { body } = document;

function handleScroll() {
  const scrollTop = window.pageYOffset;
  const passed100vh = scrollTop > window.innerHeight;

  // Add class when scrolled down a bit
  body.classList.toggle('is-scrolled', scrollTop > 20);

  // Add class after scrolling more than 100vh
  body.classList.toggle('is-bar-visible', passed100vh);

  // Detect scroll direction
  body.classList.toggle('is-scrolled-up', scrollTop < lastScrollTop);

  lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;

  ticking = false;
}

window.addEventListener(
  'scroll',
  () => {
    if (!ticking) {
      requestAnimationFrame(handleScroll);
      ticking = true;
    }
  },
  { passive: true },
);

// *******************************************************************************
// Toggle header classes
// *******************************************************************************

const toggleMenuClass = (toggle) => {
  document.body.classList.toggle('is-open-menu', toggle);
  toggleBodyScrollLock(toggle);
};

attachEvent('.hamburger', 'click', () => {
  toggleMenuClass(!document.body.classList.contains('is-open-menu'));
});

attachEvent('[data-close-menu]', 'click', () => {
  toggleMenuClass(false);
});
